import {getData, postData} from './redux_data';
import {
    GET_TIPOS_GASTO,
    ADD_TIPO_GASTO,
    DELETE_TIPO_GASTO,
    UPDATE_TIPOS_GASTO,
    MODIFY_TIPO_GASTO,
} from '../constants/action_types';

export function getTiposGasto() {
    return getData('cvtipogastos', GET_TIPOS_GASTO);
}

export function addTipoGasto(tipoGasto) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_GASTO, payload: tipoGasto });
    }
}

export function removeTipoGasto(tipoGasto) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_GASTO, payload: tipoGasto });
    }
}

export function modifyTipoGasto(tipoGasto) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_GASTO, payload: tipoGasto });
    }
}

export function updateTiposGastoDB (tipoGasto) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_TIPOS_GASTO, payload: tipoGasto })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'cvtipogastos/gastos', tipoGasto,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_TIPOS_GASTO + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_tipo_gasto'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_tipo_gasto'
    //         });
    //     });
    // }

    return postData('cvtipogastos/gastos', UPDATE_TIPOS_GASTO, tipoGasto, 'Tipos de gasto actualizados', undefined);

}

